import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { WelcomeComponent } from "./welcome.component";
import { VideoWrapperComponent } from "../main-game/after-main-game/video-wrapper.component";

import { MainGameFinishedComponent } from "../main-game/main-game-finished/main-game-finished.component";

import { Interview2QuestionComponent } from "../interview2-question/interview2-question.component";
import { Interview3QuestionComponent } from "../interview3-question/interview3-question.component";

import { IntroVideoWrapperComponent } from "./intro-video/intro-video-wrapper.component";

import { VideosWrapperComponent } from "../result/candidate-story/videos-wrapper.component";
import { ScienceComponent } from "../core/science/science.component";
import { AuthGuard } from "../auth/auth-guard.service";
import { HrAuthGuard } from "../auth/hr-auth-guard.service";
import { ReflectionComponent } from "../result/reflection/reflection.component";
import { FinishedComponent } from "../result/finished/finished.component";
import { QuestionComponent } from "../question/question.component";
import { RatingComponent } from "../rating/rating.component";
import { RatingIntroComponent } from "../rating/intro/intro.component";
import { RatingFinishedComponent } from "../rating/rating-finished/rating-finished.component";
import { StartComponent } from "../start/start.component";
import { QuizComponent } from "../quiz/quiz.component";
import { AuthGuardNoLoad } from "../auth/auth-guard-noload.service";
import { ClientComponent } from "../client/client.component";
import { AuthGuardSuper } from "../auth/auth-guard-super";
import { TermsOfUseComponent } from "../terms-of-use/terms-of-use.component";
import { AuthGuardNone } from "../auth/auth-guard-none";
import { CodeComponent } from "../code/code.component";
import { TemplateComponent } from "../template/template.component";
import { ContentComponent } from "../content/content.component";
import { ManageVideosComponent } from "../manage-videos/manage-videos.component";
import { UserComponent } from "../user/user.component";
import { ReportComponent } from "../report/report.component";
import { LibraryComponent } from "../library/library.component";
import { EnderComponent } from "../ender/ender.component";
import { PodcastComponent } from "../podcast/podcast.component";
import { FullnameComponent } from "../fullname/fullname.component";
import { ActionReportComponent } from "../action-report/action-report.component";
import { ResearchComponent } from "../research/research.component";
import { ReflectionsComponent } from "../reflections/reflections.component";
import { ClLinkComponent } from "../cl-link/cl-link.component";
import { PreviewTrainingComponent } from "../preview-training/preview-training.component";
import { MonitorComponent } from "../monitor/monitor.component";
import { SendReflectionsComponent } from "../send-reflections/send-reflections.component";
import { SharedReflectionsComponent } from "../shared-reflections/shared-reflections.component";
import { FeedbackComponent } from "../feedback/feedback.component";
import { FeedbackQuestionComponent } from "../feedback-question/feedback-question.component";
import { UserDetailComponent } from "../user-detail/user-detail.component";
import { ReferencesComponent } from "../references/references.component";
import { GlobalSearchReplaceComponent } from "../content/global-search-replace/global-search-replace.component";
import { AdhocReportComponent } from "../adhoc-report/adhoc-report.component";

const welcomeRoutes: Routes = [

  {
    path: "read",
    component: WelcomeComponent,
    canActivate: [AuthGuard]
  },
  { path: "welcome", component: WelcomeComponent, canActivate: [AuthGuard] },
  { path: 'rating/results', component: RatingFinishedComponent, canActivate: [AuthGuard] },
  { path: 'rating/:section', component: RatingComponent, canActivate: [AuthGuard] },
  { path: 'rating/intro/:section', component: RatingIntroComponent, canActivate: [AuthGuard] },
  {
    path: 'client/:clientId/code', component: CodeComponent, canActivate: [AuthGuardSuper]
  },
  {
    path: 'code/all', component: CodeComponent, canActivate: [AuthGuardSuper]
  },
  {
    path: 'template/all', component: TemplateComponent, canActivate: [AuthGuardSuper]
  },
  {
    path: 'feedback-questions', component: FeedbackQuestionComponent, canActivate: [AuthGuardSuper]
  },
  {
    path: 'client/:clientId/code/:codeId', component: ContentComponent, canActivate: [AuthGuardSuper]
  },
  {
    path: 'client/:clientId/user', component: UserComponent, canActivate: [AuthGuardSuper],
  },
  {
    path: 'user/:userId', component: UserDetailComponent, canActivate: [AuthGuardSuper],
  },
  {
    path: 'client/:clientId/report', component: ReportComponent, canActivate: [HrAuthGuard],
  },
  {
    path: 'client/:clientId/actions', component: ActionReportComponent, canActivate: [HrAuthGuard],
  },
  {
    path: 'content/all', component: ContentComponent, canActivate: [AuthGuardSuper]
  },
  {
    path: 'manage-videos', component: ManageVideosComponent, canActivate: [AuthGuardSuper]
  },
  {
    path: 'complete-content-library', component: EnderComponent, canActivate: [AuthGuard]
  },
  {
    path: 'content/global-search-replace', component: GlobalSearchReplaceComponent, canActivate: [AuthGuardSuper]
  },
  {
    path: 'research', component: ResearchComponent, canActivate: [AuthGuard]
  },
  {
    path: 'references', component: ReferencesComponent
  },
  {
    path: 'reflections', component: ReflectionsComponent, canActivate: [AuthGuard]
  },
  {
    path: 'case-studies', component: ReflectionsComponent, canActivate: [AuthGuard]
  },
  {
    path: 'link', component: ClLinkComponent, canActivate: [AuthGuard]
  },
  {
    path: 'podcast',
    component: PodcastComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "library",
    component: LibraryComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "after-main-game",
    component: VideoWrapperComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "video",
    component: VideoWrapperComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "videos",
    component: VideosWrapperComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "main-game-finished",
    component: MainGameFinishedComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "interview2-question",
    component: Interview2QuestionComponent,
    canActivate: [AuthGuard]
  },

  {
    path: "sometimes",
    component: Interview3QuestionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "sometime",
    component: Interview2QuestionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "interview3-question",
    component: Interview3QuestionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "intro-video",
    component: IntroVideoWrapperComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "auto-play-video",
    component: IntroVideoWrapperComponent,
    canActivate: [AuthGuard]
  },
  { path: "preview/training", component: PreviewTrainingComponent, canActivate: [HrAuthGuard] },
  {
    path: "result/candidate-story",
    component: VideosWrapperComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "cpd-certificate/name",
    component: FullnameComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "reflection",
    component: ReflectionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "result/finished",
    component: FinishedComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "actions",
    component: FinishedComponent,
    canActivate: [AuthGuard]
  },
  {
    path: "reminders",
    component: FinishedComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'question',
    component: QuestionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'expand',
    component: QuestionComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'start',
    component: StartComponent,
    canActivate: [AuthGuardNoLoad]
  },
  {
    path: 'client',
    component: ClientComponent,
    canActivate: [AuthGuardSuper]
  },

  {
    path: 'monitor',
    component: MonitorComponent,
    canActivate: [AuthGuardSuper]
  },
  {

    path: 'quiz',
    component: QuizComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'send-reflections',
    component: SendReflectionsComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'shared-reflections',
    component: SharedReflectionsComponent,
    canActivate: [AuthGuardSuper]
  },
  {
    path: 'feedback',
    component: FeedbackComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'adhoc-report',
    component: AdhocReportComponent,
    canActivate: [AuthGuardSuper]
  },
  { path: 'terms-of-use', component: TermsOfUseComponent, canActivate: [AuthGuardNone] },

  { path: "science", component: ScienceComponent, canActivate: [AuthGuard] },

  { path: '**', redirectTo: '/start', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forChild(welcomeRoutes)],
  exports: [RouterModule],
  providers: [
    AuthGuardSuper,
    AuthGuardNoLoad,
  ]
})
export class WelcomeRoutingModule { }
